




import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.min.css';

@Component({})
export default class Slider extends Vue {
  @Prop() value!: [];

  mounted() {
    let slider = noUiSlider.create((<any>this.$refs)["slider"], {
      start: this.value,
      connect: true,
      tooltips: [true, true],
      range: {
        'min': 0,
        'max': 100,
      },
      step: 5,
    });

    slider.on('change', (values) => this.input(values))
  }

  @Emit() input(values) {
    console.log(values);
  }
}
